import { GetCategoriesIcon, GetSportIcon } from 'assets/icons';
import { LiveDetailsState } from 'features/live/interface/live';
import { useMemo } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import LiveAnimatedDot from 'shared/components/liveAnimatedDot';
import { APP_URL } from 'shared/constants/common';
import { getLiveEventTimeString } from 'shared/util/getLiveEventTime';
import { getParticipants, removeMultipleDash, removeSpecialCharacter, showAdvanceForTennis } from 'shared/util/utility';

interface NavigationItemProps {
	eventsListDetails: LiveDetailsState;
}
interface ScoreItemProps {
	score: string | number;
}
const NavigationItemLive = ({ eventsListDetails }: NavigationItemProps) => {
	const location = useLocation();
	const getLiveEventId = parseInt(location.pathname.substring(location.pathname.lastIndexOf('/') + 1));
	const generateUrlLiveEvents = (item: LiveDetailsState) => {
		return {
			pathname: removeMultipleDash(
				`${APP_URL.live}/${removeSpecialCharacter(item.categoryName)}/${removeSpecialCharacter(item.eventName)}/${item.eventId}`,
			),
			state: {
				categoryName: item.categoryName,
				eventId: item.eventId,
			},
		};
	};
	const generatedPathname = generateUrlLiveEvents(eventsListDetails).pathname;
	const generatedId = parseInt(generatedPathname.substring(generatedPathname.lastIndexOf('/') + 1));

	const ScoreItem = (props: ScoreItemProps) => (
		<div className="score__item">
			<p>{showAdvanceForTennis(props.score)}</p>
		</div>
	);

	const liveEventTimeString = useMemo(
		() => getLiveEventTimeString(eventsListDetails.sportId, eventsListDetails.time),
		[eventsListDetails.sportId, eventsListDetails.time],
	);

	const getParticipantsElemenents = getParticipants(eventsListDetails);
	const participant_1 = <p>{getParticipantsElemenents[0]}</p>;
	const participant_2 = <p>{getParticipantsElemenents[1]}</p>;

	return (
		<NavLink
			className={`navigation__item ${getLiveEventId === generatedId && 'active'}`}
			to={generateUrlLiveEvents(eventsListDetails)}
			data-cy="event-navigation"
		>
			<div className="live_item_content_wrapper">
				<div className="icons_time_wrapper">
					<span className="game_time_status">
						{eventsListDetails.infos}
						{liveEventTimeString && <LiveAnimatedDot />}
						{liveEventTimeString}
					</span>
					<div className="icons_category">
						<GetSportIcon id={eventsListDetails.sportId} className="navigation__icon" />
						<GetCategoriesIcon
							category={{
								sportId: eventsListDetails.sportId,
								parentCategory: eventsListDetails.categoryId,
								categoryId: eventsListDetails.parentId,
							}}
							className="navigation__icon"
						/>
						<p className="category_name">{eventsListDetails.categoryName}</p>
					</div>
				</div>
				<div className="match__score">
					<div className="team__wrap">
						<div className="participant_single">{participant_1}</div>
						<div className="participant_single">{participant_2}</div>
					</div>
					<div className="scores__wrap">
						{/*eslint-disable-next-line @typescript-eslint/no-non-null-assertion*/}
						<ScoreItem score={eventsListDetails.score ? eventsListDetails.score.split(':')[0]! : '-'} />
						{/*eslint-disable-next-line @typescript-eslint/no-non-null-assertion*/}
						<ScoreItem score={eventsListDetails.score ? eventsListDetails.score.split(':')[1]! : '-'} />
					</div>
				</div>
			</div>
		</NavLink>
	);
};

export default NavigationItemLive;
